import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import RouteIcon from '@mui/icons-material/Route';
import { useWarbandStore } from '../../stores/warbandStore';
import { WarbandPage } from '../../types';
import ChecklistIcon from '@mui/icons-material/Checklist';
import SportsKabaddiIcon from '@mui/icons-material/SportsKabaddi';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const pageActions: Array<{ page: WarbandPage; label: string; icon: React.ReactNode }> = [
//   { page: 'manage', label: 'Manage', icon: <SettingsIcon /> },
  { page: 'pregame', label: 'Before Game', icon: <ChecklistIcon /> },
  { page: 'play', label: 'Play', icon: <SportsKabaddiIcon /> },
  { page: 'postgame', label: 'After Game', icon: <EmojiEventsIcon /> },
];

export const PageNavigationMenu: React.FC = () => {
  const { currentPage, navigateToPage, selectedWarbandId } = useWarbandStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const current = pageActions.find((action) => action.page === currentPage);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (page: WarbandPage) => {
    navigateToPage(page);
    handleClose();
  };

  if (!selectedWarbandId || currentPage === 'manage') return null;

  return (
    <>
      <Button
        size='small'
        variant='contained'
        color="primary"
        startIcon={current?.icon ?? <RouteIcon />}
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        sx={{ textTransform: 'none', fontWeight: 500 }}
      >
        {current?.label ?? 'Page'}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {pageActions.map((action) => (
          <MenuItem
            key={action.page}
            selected={action.page === currentPage}
            onClick={() => handleSelect(action.page)}
          >
            <ListItemIcon>{action.icon}</ListItemIcon>
            <ListItemText>{action.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
